import React from "react";
import "./InvestorsSection.scss";
import surge from "../../assets/Surge_Twitter1.png";
import tigerGlobal from "../../assets/Tiger_Global2.png";
import gsv from "../../assets/Outlined-Blue-3.png";
import blume4 from "../../assets/blume4.png";
import falcon from "../../assets/falcon5.png";
import rtp from "../../assets/rtp-global_6.png";
const InvestorsSection = () => {
	return (
		<div className='wrapper' style={{}}>
			<div className='investors__section'>
				<h3 className='investors__section__heading'>Backed by the best</h3>
				<div className='investors__section__el1'>
					<img src={surge} alt='surge' />
				</div>
				<div className='investors__section__el2'>
					<img src={tigerGlobal} alt='tigerGlobal' />
				</div>
				<div className='investors__section__el3'>
					<img src={gsv} alt='gsv' />
				</div>
				<div className='investors__section__el4'>
					<img src={blume4} alt='blume4' />
				</div>
				<div className='investors__section__el5'>
					<img src={falcon} alt='falcon' />
				</div>
				<div className='investors__section__el6'>
					<img src={rtp} alt='rtp' />
				</div>
			</div>
		</div>
	);
};

export default InvestorsSection;
